<ng-container *appLoad="let companyId of companyId$">
  <app-audit-list
    [entityType]="entityType"
    [entityId]="companyId">
  </app-audit-list>
</ng-container> 